import { useGetMeUserProfileQuery } from "services/graphql";

export function useGetUserProfile() {
  const { data, loading, error } = useGetMeUserProfileQuery();

  const profileData = data?.me;

  return { profileData, loading, error };
}
